module.exports = __webpack_public_path__ + "static/media/banner-2.84200939.jpg";